import React, { useState } from 'react';
import './FeedbackForm.css';

const feedbackTranslations = {
  es: {
    title: 'Comentarios y Sugerencias',
    subtitle: 'Ayúdanos a mejorar la aplicación o comparte tus expectativas',
    typeLabel: 'Tipo de comentario',
    improvement: 'Mejora de funcionalidad',
    expectation: 'Expectativa de la app',
    nameLabel: 'Nombre (opcional)',
    emailLabel: 'Email (opcional)',
    commentLabelImprovement: '¿Qué funcionalidad te gustaría mejorar o agregar?',
    commentLabelExpectation: '¿Qué esperas de una aplicación como esta?',
    placeholderImprovement: 'Describe la mejora o funcionalidad que te gustaría ver...',
    placeholderExpectation: 'Comparte tus expectativas y cómo te gustaría usar esta aplicación...',
    cancel: 'Cancelar',
    submit: 'Enviar Comentario',
    thanks: '¡Gracias por tu feedback!',
    opened: 'Se ha abierto tu cliente de correo con el mensaje listo para enviar.',
    recipient: 'Destinatario',
    fallback: 'Si no se abrió tu cliente de correo, envía un correo a cpenafiel1@uc.cl con tu comentario. El contenido también se copió al portapapeles.',
    emptyError: 'Por favor, escribe tus comentarios antes de enviar.'
  },
  en: {
    title: 'Comments & Suggestions',
    subtitle: 'Help us improve the app or share your expectations',
    typeLabel: 'Comment type',
    improvement: 'Feature improvement',
    expectation: 'App expectations',
    nameLabel: 'Name (optional)',
    emailLabel: 'Email (optional)',
    commentLabelImprovement: 'What feature would you like to improve or add?',
    commentLabelExpectation: 'What do you expect from an app like this?',
    placeholderImprovement: 'Describe the improvement or feature you would like to see...',
    placeholderExpectation: 'Share your expectations and how you would like to use this app...',
    cancel: 'Cancel',
    submit: 'Send Comment',
    thanks: 'Thanks for your feedback!',
    opened: 'Your email client has been opened with the message ready to send.',
    recipient: 'Recipient',
    fallback: 'If your email client did not open, send an email to cpenafiel1@uc.cl with your comment. The content was also copied to the clipboard.',
    emptyError: 'Please write your comments before sending.'
  },
  ar: {
    title: 'تعليقات واقتراحات',
    subtitle: 'ساعدنا في تحسين التطبيق أو شارك توقعاتك',
    typeLabel: 'نوع التعليق',
    improvement: 'تحسين وظيفة',
    expectation: 'توقعات التطبيق',
    nameLabel: 'الاسم (اختياري)',
    emailLabel: 'البريد الإلكتروني (اختياري)',
    commentLabelImprovement: 'ما الوظيفة التي ترغب في تحسينها أو إضافتها؟',
    commentLabelExpectation: 'ما الذي تتوقعه من تطبيق كهذا؟',
    placeholderImprovement: 'صف التحسين أو الوظيفة التي ترغب في رؤيتها...',
    placeholderExpectation: 'شارك توقعاتك وكيف ترغب في استخدام هذا التطبيق...',
    cancel: 'إلغاء',
    submit: 'إرسال التعليق',
    thanks: 'شكرًا لملاحظاتك!',
    opened: 'تم فتح عميل البريد الإلكتروني مع الرسالة جاهزة للإرسال.',
    recipient: 'المستلم',
    fallback: 'إذا لم يفتح عميل البريد، أرسل بريدًا إلى cpenafiel1@uc.cl مع تعليقك. تم نسخ المحتوى إلى الحافظة.',
    emptyError: 'يرجى كتابة تعليقك قبل الإرسال.'
  },
  fr: {
    title: 'Commentaires et suggestions',
    subtitle: 'Aidez-nous à améliorer l’application ou partagez vos attentes',
    typeLabel: 'Type de commentaire',
    improvement: 'Amélioration de fonctionnalité',
    expectation: 'Attentes de l’app',
    nameLabel: 'Nom (optionnel)',
    emailLabel: 'Email (optionnel)',
    commentLabelImprovement: 'Quelle fonctionnalité souhaitez-vous améliorer ou ajouter ?',
    commentLabelExpectation: 'Qu’attendez-vous d’une application comme celle-ci ?',
    placeholderImprovement: 'Décrivez l’amélioration ou la fonctionnalité souhaitée...',
    placeholderExpectation: 'Partagez vos attentes et comment vous souhaitez utiliser cette application...',
    cancel: 'Annuler',
    submit: 'Envoyer',
    thanks: 'Merci pour votre retour !',
    opened: 'Votre client de messagerie a été ouvert avec le message prêt à être envoyé.',
    recipient: 'Destinataire',
    fallback: 'Si votre client ne s’ouvre pas, envoyez un email à cpenafiel1@uc.cl avec votre commentaire. Le contenu a aussi été copié.',
    emptyError: 'Veuillez écrire votre commentaire avant d’envoyer.'
  },
  pt: {
    title: 'Comentários e Sugestões',
    subtitle: 'Ajude-nos a melhorar o app ou compartilhe suas expectativas',
    typeLabel: 'Tipo de comentário',
    improvement: 'Melhoria de funcionalidade',
    expectation: 'Expectativas do app',
    nameLabel: 'Nome (opcional)',
    emailLabel: 'Email (opcional)',
    commentLabelImprovement: 'Que funcionalidade você gostaria de melhorar ou adicionar?',
    commentLabelExpectation: 'O que você espera de um app como este?',
    placeholderImprovement: 'Descreva a melhoria ou funcionalidade que gostaria de ver...',
    placeholderExpectation: 'Compartilhe suas expectativas e como gostaria de usar este app...',
    cancel: 'Cancelar',
    submit: 'Enviar comentário',
    thanks: 'Obrigado pelo seu feedback!',
    opened: 'Seu cliente de email foi aberto com a mensagem pronta para enviar.',
    recipient: 'Destinatário',
    fallback: 'Se o cliente de email não abrir, envie um email para cpenafiel1@uc.cl com seu comentário. O conteúdo foi copiado.',
    emptyError: 'Escreva seus comentários antes de enviar.'
  },
  de: {
    title: 'Kommentare und Vorschläge',
    subtitle: 'Hilf uns, die App zu verbessern oder teile deine Erwartungen',
    typeLabel: 'Kommentarart',
    improvement: 'Funktionsverbesserung',
    expectation: 'Erwartungen an die App',
    nameLabel: 'Name (optional)',
    emailLabel: 'E-Mail (optional)',
    commentLabelImprovement: 'Welche Funktion möchtest du verbessern oder hinzufügen?',
    commentLabelExpectation: 'Was erwartest du von einer App wie dieser?',
    placeholderImprovement: 'Beschreibe die Verbesserung oder Funktion, die du sehen möchtest...',
    placeholderExpectation: 'Teile deine Erwartungen und wie du diese App nutzen möchtest...',
    cancel: 'Abbrechen',
    submit: 'Kommentar senden',
    thanks: 'Danke für dein Feedback!',
    opened: 'Dein E-Mail-Client wurde geöffnet, die Nachricht ist bereit zum Senden.',
    recipient: 'Empfänger',
    fallback: 'Wenn dein E-Mail-Client nicht geöffnet wurde, sende eine E-Mail an cpenafiel1@uc.cl mit deinem Kommentar. Der Inhalt wurde kopiert.',
    emptyError: 'Bitte schreibe deinen Kommentar, bevor du sendest.'
  },
  pl: {
    title: 'Komentarze i sugestie',
    subtitle: 'Pomóż nam ulepszyć aplikację lub podziel się oczekiwaniami',
    typeLabel: 'Rodzaj komentarza',
    improvement: 'Ulepszenie funkcji',
    expectation: 'Oczekiwania wobec aplikacji',
    nameLabel: 'Imię (opcjonalnie)',
    emailLabel: 'Email (opcjonalnie)',
    commentLabelImprovement: 'Jaką funkcję chcesz ulepszyć lub dodać?',
    commentLabelExpectation: 'Czego oczekujesz od takiej aplikacji?',
    placeholderImprovement: 'Opisz ulepszenie lub funkcję, którą chcesz zobaczyć...',
    placeholderExpectation: 'Podziel się oczekiwaniami i tym, jak chcesz używać tej aplikacji...',
    cancel: 'Anuluj',
    submit: 'Wyślij',
    thanks: 'Dziękujemy za opinię!',
    opened: 'Twój klient poczty został otwarty z gotową wiadomością.',
    recipient: 'Odbiorca',
    fallback: 'Jeśli klient poczty się nie otworzył, wyślij email na cpenafiel1@uc.cl z komentarzem. Treść została skopiowana.',
    emptyError: 'Proszę wpisać komentarz przed wysłaniem.'
  },
  it: {
    title: 'Commenti e Suggerimenti',
    subtitle: 'Aiutaci a migliorare l’app o condividi le tue aspettative',
    typeLabel: 'Tipo di commento',
    improvement: 'Miglioramento funzionalità',
    expectation: 'Aspettative app',
    nameLabel: 'Nome (opzionale)',
    emailLabel: 'Email (opzionale)',
    commentLabelImprovement: 'Quale funzionalità vuoi migliorare o aggiungere?',
    commentLabelExpectation: 'Cosa ti aspetti da un’app come questa?',
    placeholderImprovement: 'Descrivi il miglioramento o la funzionalità che vorresti vedere...',
    placeholderExpectation: 'Condividi le tue aspettative e come vorresti usare questa app...',
    cancel: 'Annulla',
    submit: 'Invia',
    thanks: 'Grazie per il tuo feedback!',
    opened: 'Il tuo client email è stato aperto con il messaggio pronto.',
    recipient: 'Destinatario',
    fallback: 'Se il client non si apre, invia un’email a cpenafiel1@uc.cl con il commento. Il contenuto è stato copiato.',
    emptyError: 'Scrivi il commento prima di inviare.'
  },
  ko: {
    title: '의견 및 제안',
    subtitle: '앱 개선을 도와주시거나 기대를 공유해주세요',
    typeLabel: '댓글 유형',
    improvement: '기능 개선',
    expectation: '앱 기대',
    nameLabel: '이름 (선택)',
    emailLabel: '이메일 (선택)',
    commentLabelImprovement: '어떤 기능을 개선하거나 추가하고 싶나요?',
    commentLabelExpectation: '이 앱에서 무엇을 기대하시나요?',
    placeholderImprovement: '원하는 개선 사항이나 기능을 설명해주세요...',
    placeholderExpectation: '기대 사항과 사용 방법을 알려주세요...',
    cancel: '취소',
    submit: '보내기',
    thanks: '피드백 감사합니다!',
    opened: '이메일 클라이언트가 열렸습니다. 전송만 하면 됩니다.',
    recipient: '수신자',
    fallback: '이메일이 열리지 않으면 cpenafiel1@uc.cl로 보내주세요. 내용이 클립보드에 복사되었습니다.',
    emptyError: '보내기 전에 내용을 작성해주세요.'
  },
  zh: {
    title: '意见与建议',
    subtitle: '帮助我们改进应用或分享你的期望',
    typeLabel: '评论类型',
    improvement: '功能改进',
    expectation: '应用期望',
    nameLabel: '姓名（可选）',
    emailLabel: '邮箱（可选）',
    commentLabelImprovement: '你希望改进或添加哪些功能？',
    commentLabelExpectation: '你对这类应用有什么期待？',
    placeholderImprovement: '描述你想看到的改进或功能...',
    placeholderExpectation: '分享你的期望和使用方式...',
    cancel: '取消',
    submit: '发送',
    thanks: '感谢你的反馈！',
    opened: '已打开邮件客户端，消息已准备好发送。',
    recipient: '收件人',
    fallback: '如果未打开邮件客户端，请发送邮件至 cpenafiel1@uc.cl，内容已复制。',
    emptyError: '发送前请填写评论内容。'
  },
  ja: {
    title: 'コメントと提案',
    subtitle: 'アプリ改善のためにご意見をお寄せください',
    typeLabel: 'コメントの種類',
    improvement: '機能改善',
    expectation: 'アプリの期待',
    nameLabel: '名前（任意）',
    emailLabel: 'メール（任意）',
    commentLabelImprovement: '改善または追加したい機能は？',
    commentLabelExpectation: 'このようなアプリに何を期待しますか？',
    placeholderImprovement: '改善や追加したい機能を記入してください...',
    placeholderExpectation: '期待や利用方法を共有してください...',
    cancel: 'キャンセル',
    submit: '送信',
    thanks: 'ご意見ありがとうございます！',
    opened: 'メールクライアントが開きました。送信してください。',
    recipient: '宛先',
    fallback: '開かない場合は cpenafiel1@uc.cl へ送信してください。内容はコピー済みです。',
    emptyError: '送信前にコメントを入力してください。'
  },
  he: {
    title: 'תגובות והצעות',
    subtitle: 'עזרו לנו לשפר את האפליקציה או שתפו את הציפיות שלכם',
    typeLabel: 'סוג תגובה',
    improvement: 'שיפור פונקציונליות',
    expectation: 'ציפיות מהאפליקציה',
    nameLabel: 'שם (אופציונלי)',
    emailLabel: 'אימייל (אופציונלי)',
    commentLabelImprovement: 'איזו פונקציה תרצה לשפר או להוסיף?',
    commentLabelExpectation: 'מה אתה מצפה מאפליקציה כזו?',
    placeholderImprovement: 'תאר את השיפור או הפונקציה שתרצה לראות...',
    placeholderExpectation: 'שתף את הציפיות וכיצד תרצה להשתמש באפליקציה...',
    cancel: 'ביטול',
    submit: 'שלח',
    thanks: 'תודה על המשוב!',
    opened: 'נפתח לקוח הדוא״ל עם ההודעה מוכנה לשליחה.',
    recipient: 'נמען',
    fallback: 'אם לקוח הדוא״ל לא נפתח, שלח ל‑cpenafiel1@uc.cl את תגובתך. התוכן הועתק ללוח.',
    emptyError: 'אנא כתוב את תגובתך לפני השליחה.'
  },
  ru: {
    title: 'Комментарии и предложения',
    subtitle: 'Помогите улучшить приложение или поделитесь ожиданиями',
    typeLabel: 'Тип комментария',
    improvement: 'Улучшение функции',
    expectation: 'Ожидания от приложения',
    nameLabel: 'Имя (необязательно)',
    emailLabel: 'Email (необязательно)',
    commentLabelImprovement: 'Какую функцию вы хотели бы улучшить или добавить?',
    commentLabelExpectation: 'Чего вы ожидаете от такого приложения?',
    placeholderImprovement: 'Опишите улучшение или функцию, которую хотите увидеть...',
    placeholderExpectation: 'Поделитесь ожиданиями и тем, как хотите использовать приложение...',
    cancel: 'Отмена',
    submit: 'Отправить',
    thanks: 'Спасибо за отзыв!',
    opened: 'Почтовый клиент открыт, сообщение готово к отправке.',
    recipient: 'Получатель',
    fallback: 'Если почтовый клиент не открылся, отправьте письмо на cpenafiel1@uc.cl. Содержимое скопировано.',
    emptyError: 'Пожалуйста, напишите комментарий перед отправкой.'
  }
};

const FeedbackForm = ({ onClose, language = 'es' }) => {
  const t = feedbackTranslations[language] || feedbackTranslations.es;
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [feedback, setFeedback] = useState('');
  const [feedbackType, setFeedbackType] = useState('improvement');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!feedback.trim()) {
      alert(t.emptyError);
      return;
    }

    const subject = `Feedback APP EMDR - ${feedbackType === 'improvement' ? t.improvement : t.expectation}`;
    const bodyText = `Nombre: ${name || 'No especificado'}\n` +
      `Email: ${email || 'No especificado'}\n` +
      `Tipo: ${feedbackType === 'improvement' ? t.improvement : t.expectation}\n\n` +
      `Comentarios:\n${feedback}`;

    // Intentar abrir el cliente de correo
    const subjectEncoded = encodeURIComponent(subject);
    const bodyEncoded = encodeURIComponent(bodyText);
    const mailtoLink = `mailto:cpenafiel1@uc.cl?subject=${subjectEncoded}&body=${bodyEncoded}`;
    
    // Copiar al portapapeles también
    try {
      await navigator.clipboard.writeText(`Para: cpenafiel1@uc.cl\nAsunto: ${subject}\n\n${bodyText}`);
    } catch (err) {
      console.log('No se pudo copiar al portapapeles:', err);
    }
    
    // Abrir el cliente de correo
    window.location.href = mailtoLink;
    
    setSubmitted(true);
    
    // Cerrar después de 5 segundos
    setTimeout(() => {
      onClose();
    }, 5000);
  };

  if (submitted) {
    return (
      <div className="feedback-overlay" onClick={onClose}>
        <div className="feedback-box" onClick={(e) => e.stopPropagation()}>
          <div className="feedback-success">
            <h3>{t.thanks}</h3>
            <p style={{ marginBottom: '15px' }}>
              {t.opened}
            </p>
            <p style={{ fontSize: '13px', color: '#666', marginBottom: '10px' }}>
              <strong>{t.recipient}:</strong> cpenafiel1@uc.cl
            </p>
            <p style={{ fontSize: '12px', color: '#999', margin: 0 }}>
              {t.fallback}
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="feedback-overlay" onClick={onClose}>
      <div className="feedback-box" onClick={(e) => e.stopPropagation()}>
        <button className="feedback-close" onClick={onClose}>×</button>
        <h2 className="feedback-title">{t.title}</h2>
        <p className="feedback-subtitle">{t.subtitle}</p>

        <form onSubmit={handleSubmit} className="feedback-form">
          <div className="form-group">
            <label htmlFor="feedbackType">{t.typeLabel}</label>
            <select
              id="feedbackType"
              value={feedbackType}
              onChange={(e) => setFeedbackType(e.target.value)}
            >
              <option value="improvement">{t.improvement}</option>
              <option value="expectation">{t.expectation}</option>
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="name">{t.nameLabel}</label>
            <input
              type="text"
              id="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Tu nombre"
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">{t.emailLabel}</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="tu@email.com"
            />
          </div>

          <div className="form-group">
            <label htmlFor="feedback">
              {feedbackType === 'improvement' 
                ? t.commentLabelImprovement
                : t.commentLabelExpectation}
            </label>
            <textarea
              id="feedback"
              value={feedback}
              onChange={(e) => setFeedback(e.target.value)}
              placeholder={
                feedbackType === 'improvement'
                  ? t.placeholderImprovement
                  : t.placeholderExpectation
              }
              rows="6"
              required
            />
          </div>

          <div className="feedback-buttons">
            <button type="button" className="feedback-cancel" onClick={onClose}>
              {t.cancel}
            </button>
            <button type="submit" className="feedback-submit">
              {t.submit}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default FeedbackForm;
